import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Card,
    CardContent,
    Grid,
    TextField,
    CardActions,
    Button
} from '@mui/material';
import useVideoMgtHook from '../../hooks/video-mgt-hook';


export default function VideoForm({ mode, button_title }) {
    const { id } = useParams();

    const { form_data, handelDataChange, onFileThumbnailChange, actionSave, fetchVideoDetail } = useVideoMgtHook()

    const handleSaveButton = async () => {
        let result = await actionSave(mode)
        alert(result.msg)
        if (result.result) {
            window.location.href = "/admin/video";
        }
    }

    useEffect(() => {
        const asyncFn = async () => {
            if (mode === 'edit') {
                await fetchVideoDetail(id)
            }
        }
        asyncFn()
    }, [])

    return (
        <>
            <Card style={{ marginTop: '1.5rem', marginRight: '1%', marginLeft: '1%' }}>
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={6}>
                            <TextField
                                fullWidth
                                id="video_name"
                                label="หัวข้อ Video"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={form_data.video_name}
                                onChange={(e) => handelDataChange(e.target.value, 'video_name')}
                            />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <TextField
                                fullWidth
                                id="video_body"
                                label="เนื้อหา Video"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={form_data.video_body}
                                onChange={(e) => handelDataChange(e.target.value, 'video_body')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="video_desc"
                                label="รายละเอียด Video"
                                variant="outlined"
                                multiline
                                minRows={5}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={form_data.video_desc}
                                onChange={(e) => handelDataChange(e.target.value, 'video_desc')}
                            />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <TextField
                                fullWidth
                                id="video_url"
                                label="URL Video"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={form_data.video_url}
                                onChange={(e) => handelDataChange(e.target.value, 'video_url')}
                            />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <TextField
                                fullWidth
                                id="video_thumbnail"
                                label="รูป Video"
                                // value={news_thumbnail}
                                onChange={event => onFileThumbnailChange(event, 'video_thumbnail')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                sx={{
                                    backgroundColor: "#FFFFFF"
                                }}
                                type="file"
                                inputProps={{ accept: 'image/*' }}
                            />
                        </Grid>
                        {
                            form_data.video_thumbnail !== undefined && form_data.video_thumbnail !== '' ?
                                <Grid item xs={12}>
                                    <img
                                        alt="Logo"
                                        src={form_data.video_thumbnail}
                                        style={{ height: 400 }}
                                    />
                                </Grid>
                                : null
                        }
                    </Grid>
                </CardContent>
                <CardActions>
                    <Grid
                        container
                        spacing={2}
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                    >
                        <Grid item ></Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleSaveButton}
                            >
                                {button_title}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={() => { window.location.href = "/admin/video"; }}
                            >
                                BACK
                            </Button>
                        </Grid>
                    </Grid>
                </CardActions>
            </Card>
        </>
    )
}